import { Redirect, Route, Switch } from "./lib/router";
import { useAuth } from "./contexts";
import { Loader } from "./components/Common";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import NewSession from "./pages/NewSession";
import Conversation from "./pages/Conversation";
import History from "./pages/History";
import Progress from "./pages/Progress";
import SettingsPage from "./pages/Settings";
import AdminScenarios from "./pages/AdminScenarios";
import AdminUsers from "./pages/AdminUsers";
import SessionReportPage from "./pages/SessionReport";
import Gamification from "./pages/Gamification";
import NotFound from "./pages/NotFound";

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader full />;
  return user ? children : <Redirect to="/login" />;
}

function Guest({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader full />;
  return user ? <Redirect to="/dashboard" /> : children;
}

export default function App() {
  return <Switch>
    <Route path="/"><Redirect to="/dashboard" /></Route>
    <Route path="/login"><Guest><Login /></Guest></Route>
    <Route path="/register"><Guest><Register /></Guest></Route>
    <Route path="/dashboard"><Protected><Dashboard /></Protected></Route>
    <Route path="/new-session"><Protected><NewSession /></Protected></Route>
    <Route path="/conversation/:id"><Protected><Conversation /></Protected></Route>
    <Route path="/report/:id"><Protected><SessionReportPage /></Protected></Route>
    <Route path="/history"><Protected><History /></Protected></Route>
    <Route path="/progress"><Protected><Progress /></Protected></Route>
    <Route path="/gamification"><Protected><Gamification /></Protected></Route>
    <Route path="/settings"><Protected><SettingsPage /></Protected></Route>
    <Route path="/admin/scenarios"><Protected><AdminScenarios /></Protected></Route>
    <Route path="/admin/users"><Protected><AdminUsers /></Protected></Route>
    <Route><NotFound /></Route>
  </Switch>;
}
